import {Component, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../../../shared/services/api.service';
import {EnrollService} from '../../../../shared/services/enroll.service';
import {FormService} from '@satoris/ngx-satoris';

@Component({
  selector: 'app-activation-step-ask-device-name',
  templateUrl: './activation-step-ask-device-name.component.html',
  styleUrls: ['./activation-step-ask-device-name.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivationStepAskDeviceNameComponent {
  constructor(public api: ApiService,
              public forms: FormService,
              public enroll: EnrollService) {
    if(!this.api.setCardRenewalMode && this.api.userInfo.nationalNumber && this.api.userRole.isCustomer) {
      this.api.setPrincipalMode = true;
    }
    if(this.api.setCardRenewalMode && this.api.userInfo.deviceName) {
      this.enroll.form.controls[this.enroll.fc.DEVICE_NAME].setValue(this.api.userInfo.deviceName.split('|')[0]);
    }
  }
}
